import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { e2eLocators } from '@components/storage-accounts/add-storage-account-wizard/add-storage-account-wizard.constants';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, MbsPopupType } from 'mbs-ui-kit';
import { StoragesAvailableForCreation } from 'mbs-ui-shared/src/lib/models/StorageAccount';
import { StorageDisplayNamePipe } from 'mbs-ui-shared@utils/pipes/storage-display-name.pipe';
import { StorageTypeIconPipe } from 'mbs-ui-shared@utils/pipes/storage-type-icon.pipe';

@Component({
  selector: 'mbs-select-storage-step',
  templateUrl: './select-storage-step.component.html',
  styleUrls: ['../../add-storage-account-wizard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AlertComponent, I18NextPipe, StorageDisplayNamePipe, StorageTypeIconPipe]
})
export class SelectStorageStepComponent {
  public readonly e2eLocators = e2eLocators;
  public readonly MbsPopupType = MbsPopupType;

  @Input() error: string;
  @Input() storages: StoragesAvailableForCreation;
  @Input() wizardForm: FormGroup;
}
